


































































import { Component, Vue } from 'vue-property-decorator'
import DrawerCell from '@/components/DrawerCell.vue'
import { navigation } from '@/store/modules'

@Component({
  components: { DrawerCell }
})
export default class Drawer extends Vue {
  search = ''

  readonly logo = require('@/assets/logo-thin-orrm-light.svg')

  get panelLabel (): string {
    if (this.$route.meta && this.$route.meta.panel && this.$route.meta.panel.label) {
      if (typeof this.$route.meta.panel.label === 'string') {
        return this.$route.meta.panel.label as string
      } else if (typeof this.$route.meta.panel.label === 'function' && !(this.$route.meta.panel.label.prototype.constructor)) {
        return this.$route.meta.panel.label() as string
      }
    }
    return ''
  }

  get panelLabelComponent (): Vue | null {
    if (this.$route.meta && this.$route.meta.panel && this.$route.meta.panel.label) {
      if (this.$route.meta.panel.label.prototype && this.$route.meta.panel.label.prototype.constructor) {
        return this.$route.meta.panel.label
      }
    }
    return null
  }

  get back (): boolean {
    return this.$route.meta && this.$route.meta.panel && this.$route.meta.panel.back
  }

  get headerShadow (): boolean {
    if (this.$route.meta && this.$route.meta.style && this.$route.meta.style.headerShadow === false) {
      return false
    }
    return true
  }

  get panelIcon (): string | null {
    if (this.$route.meta && this.$route.meta.panel && this.$route.meta.panel.icon) {
      return this.$route.meta.panel.icon
    }
    return null
  }

  get open () {
    return this.$route.name !== 'Home'
  }

  openAbout () {
    navigation.setAboutOpen(true)
  }
}
